import { render, staticRenderFns } from "./OpennessWinWin.vue?vue&type=template&id=066c7d5e&scoped=true"
import script from "./OpennessWinWin.vue?vue&type=script&lang=js"
export * from "./OpennessWinWin.vue?vue&type=script&lang=js"
import style0 from "./OpennessWinWin.vue?vue&type=style&index=0&id=066c7d5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c7d5e",
  null
  
)

export default component.exports